<template>
    <div id="registryEditRulePanel" class="form-wrapper">
        <PanelDropdown v-model="folderMap" :label="$t('folderMap')" :options="folderOptions" placeholder="None"
            :tooltip="$t('tooltips.shared.folderMap')" />
        <PanelInput v-model="localForm.fileName" :label="$t('processPath')" :placeholder="$t('enterProcessPath')"
            :tooltip="$t('tooltips.shared.folderFileName')" />
        <div class="d-flex ">
            <div class="d-flex col-4" style="padding-left: 0px !important;">
                <label class="form-label ">{{ $t('allowLaunch') }}</label>
                <Tooltip :text="$t('tooltips.childLaunch.allowLaunch')">
                    <i class="ag-icon ag-icon_table_info small info-icon"></i>
                </Tooltip>
            </div>
            <div class="col-8">
                <ToggleSwitch v-model="localForm.allowLaunch" label="" :show-info="false" />
            </div>
        </div>

        <div class="d-flex ">
            <div class="d-flex col-4" style="padding-left: 0px !important;">
                <label class="form-label ">{{ $t('neverInheritFromParent') }}</label>
                <Tooltip :text="$t('tooltips.childLaunch.neverInheritFromParent')">
                    <span style="height: min-content;"> <i
                            class="ag-icon ag-icon_table_info small info-icon"></i></span>
                </Tooltip>
            </div>
            <div class="col-8">
                <ToggleSwitch v-model="localForm.neverInheritFromParent" label="" :show-info="false" />
            </div>
        </div>
        <ExpertNotes v-model="localForm.expertNotes" :max-length="1000" label="Expert Notes" />
    </div>
</template>

<script setup>
import { defineProps, ref, defineEmits, watch, computed, onMounted } from 'vue'
import ToggleSwitch from './components/toggle-switch.vue'
import PanelInput from './components/panelInput.vue'
import PanelDropdown from './components/panelDropdown.vue'
import ExpertNotes from './components/expertNotes.vue';
import { useStore } from "@/store";
import Tooltip from './components/tooltip.vue'
const store = useStore();
const props = defineProps({
    form: {
        type: Object,
        required: true,
    },
    formType: {
        type: String,
        default: 'childLaunch'
    }
})
const emit = defineEmits(['update:form'])
const folderOptions = computed(() => {
    const original = store.state.general.folderMaps || [];
    return [{ label: "None", value: null }, { label: "Any", value: -1 }, ...original];
});

const localForm = computed({
    get() {
        return props.form;
    },
    set(newVal) {
        emit('update:form', newVal);
    }
});

const folderMap = computed({
    get() {
        return localForm.value.isFolderMapIdAny ? -1 : localForm.value.folderMapId;
    },
    set(val) {
        if (val === -1) {
            localForm.value.isFolderMapIdAny = true;
            localForm.value.folderMapId = -1;
        } else if (val === null) {
            localForm.value.isFolderMapIdAny = false;
            localForm.value.folderMapId = null;
        } else {
            localForm.value.isFolderMapIdAny = false;
            localForm.value.folderMapId = val;
        }
    },
});

const appGroupInfo = computed(() => store.state.general.appGroupInfo || {});
const inheritanceOptions = computed(() => store.state.general.enums['Inheritance'] || []);

function ensureNeverInheritDefault() {
  const isNew = !localForm.value?.id;
  const hasValue = localForm.value?.neverInheritFromParent !== undefined && localForm.value?.neverInheritFromParent !== null;
  if (!isNew || hasValue) return;

  const groupInheritance = Number(appGroupInfo.value?.inheritance ?? 0);
  if (!groupInheritance) {
    localForm.value.neverInheritFromParent = false;
    return;
  }
  const neverOpt = inheritanceOptions.value.find(o => String(o.label).toLowerCase() === 'never inherit from parent');
  const bit = Number(neverOpt?.value ?? 0);
  if (!bit) {
    localForm.value.neverInheritFromParent = false;
    return;
  }
  localForm.value.neverInheritFromParent = (groupInheritance & bit) === bit;
}

onMounted(() => {
  ensureNeverInheritDefault();
});

watch([appGroupInfo, inheritanceOptions], () => {
  ensureNeverInheritDefault();
});
</script>
<style>
.form-wrapper {
    font-size: 0.8rem !important;
}

.custom-input {
    width: inherit;
}

.label-check {
    margin-left: 5px;
    margin-bottom: 0px !important;
}

.form-label {
    color: #164B6C;
    font-weight: bold;
    margin-left: 8px;
}

.info-icon {
    margin-left: 3px;
}
</style>
